import { PAY_TRANSACTION_STATUS } from '../../../utils/constants/commonValues';
import moment from 'moment';

function PaymentTrxnList(data) {
    this.tableDataTxn = this.createTableData(data);
    this.paginationTxn = this.createPaginationData(data);
}

PaymentTrxnList.prototype = Object.assign(PaymentTrxnList.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.linkDetailsDataList &&
            tableData.linkDetailsDataList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { totalElements, pageNo } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: pageNo || 0,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            communicationModeValue,
            sharedLinkId,
            sharedDate,
            transactionStatus,
            transactionId,
            transactionDate,
            paymentMode,
        } = row;
        return {
            communicationModeValue: communicationModeValue || '-',
            sharedLinkId: sharedLinkId || '',
            sharedDate: this.convertDate(sharedDate),
            transactionId: transactionId || '-',
            transactionDate: this.convertDate(transactionDate),
            paymentMode: paymentMode || '-',
            transactionStatus,
            transactionStatusView: this.getTransactionStatus(transactionStatus),
        };
    },
    getTransactionStatus(status) {
        if (!status) {
            return '-';
        }
        return PAY_TRANSACTION_STATUS[status];
    },
    convertDate(date) {
        if (!date) {
            return '-';
        }
        const dateFormat = parseInt(date, 10);
        const dateString = moment(dateFormat).format('DD/MM/YYYY');
        return dateString;
    },
});

export default PaymentTrxnList;
